<div class="location-wrapper">
  <h4>Location</h4>
  <p>This machine is currently located in {{ location | location: "cityState":false }}.</p>
  <az-map [locations]="[location]" [mapConfig]="mapConfig" id="locationMap" [markerTemplate]="markerTemplate"> </az-map>
  <ng-template #markerTemplate>
    <div class="custom-marker"></div>
    <div class="custom-marker-background"></div>
  </ng-template>
</div>
